import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cookiePolicyContainer"},[_c('div',{staticClass:"cookiePolicy"},[_c('span',[_vm._v(_vm._s(_vm.$t('policies.appUsesCookies'))+" "),_c('a',{on:{"click":_vm.viewCookiePolicyPage}},[_vm._v(_vm._s(_vm.$t('policies.cookies.title')))]),_vm._v(".")]),_c(VBtn,{staticClass:"ml-3",attrs:{"small":"","color":"secondary"},on:{"click":_vm.accept}},[_vm._v(" "+_vm._s(_vm.$t('policies.acceptBtn'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }